/** Created by azhou on 2019/3/14.*/
<template>
  <div>
    <public-title>评论详情
      <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
    </public-title>
    <div class="bg-white p-5">
      <!--订单信息-->
      <h4 class="text-left" v-if="userInfo.type != 2">采购商名称：{{CommentDetail[0].order_name}}</h4>
      <div class="mt-2 mb-2 d-center-between">
        <label class="text-muted mr-5">订单编号：<span class="text-blue">{{CommentDetail[0].order_no}}</span></label>
        <label class="text-muted" v-show="CommentDetail[0].order_title">团号：
          <span class="text-blue">{{CommentDetail[0].order_title}}</span>
        </label>
        <label class="ml-auto">评论人：<span class="text-blue">{{CommentDetail[0].comment_name}}</span></label>
      </div>
      <!--评论详情-->
      <div class="comment-wrap border mb-4" v-for="(hotelItem,index) in CommentDetail" :key="index">
        <!--酒店名称-->
        <div class="mb-3 text-left d-flex align-items-stretch">
          <img :src="hotelItem.avatar?ImgPreUrl+hotelItem.avatar:'/images/public/defaultImg.png'"
               height="60" width="60" style="border-radius: 50%;display:inline-block"/>
          <div class="ml-3 d-flex flex-column justify-content-between w-100">
            <div class="d-center-between w-100">
              <h5 class="mb-0">{{hotelItem.hotelName || hotelItem.reply_name || hotelItem.order_title}}</h5>
              <label>评论时间：{{hotelItem.comment_time | formatTimestamp(1)}}
                <span class="text-danger" v-if="hotelItem.is_verify==0">（待审核）</span>
                <span class="text-success" v-if="hotelItem.is_verify==1">（已发布）</span>
                <span class="text-danger" v-if="hotelItem.is_verify==2">（发布失败）</span>
              </label>
            </div>
            <div class="progress-wrap">
              <div class="text-muted grade-progress"><div class="form-left-text">环境设施：</div><label><span></span></label><span class="text-warning ml-3">{{hotelItem.hotel_facilities}}</span>分</div>
              <div class="text-muted grade-progress ml-3"><div class="form-left-text">服务态度：</div><label><span></span></label><span class="text-warning ml-3">{{hotelItem.hotel_environment}}</span>分</div>
            </div>
          </div>
        </div>
        <div class="text-left mt-4 mb-2" style="margin-left: 72px;">{{hotelItem.comment}}</div>
        <upload-image class="mt-3" v-if="hotelItem.comment_pic" :existImgs="hotelItem.comment_pic.split(',')"/>
        <!--酒店回复-->
        <div class="mt-4" v-if="hotelItem.reply && (hotelItem.reply_is_verify==1 || userInfo.type!==2)">
          <div class="d-center-between mb-2">
            <h5 class="font-weight-bold">商家回复：</h5>
            <span>{{hotelItem.reply_time | formatTimestamp(1)}}</span>
          </div>
          <div class="text-left p-2 bg-base" style="text-indent: 2em;">{{hotelItem.reply}}</div>
        </div>
      </div>
      <!--门店回复-->
      <div v-if="showStoreReply">
        <left-text-border  v-model="replyContent" placeholder="输入回复内容（请勿超过200字）" type="textarea"/>
        <el-button type="success" @click="replyPost" class="mt-4">提交回复</el-button>
      </div>
      <!--管理员审核-->
      <div class="mt-4" v-if="showControlBtn">
        <el-button type="success" @click="verifyComment('1')">审核通过</el-button>
        <el-button type="danger" @click="verifyComment('0')">拒绝发布</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapMutations, mapActions,mapState } from 'vuex'

  export default {
    name: 'CommentDetail',
    data () {
      return {
        replyContent:''
      }
    },
    computed: {
      ...mapState(['CommentDetail']),
      ...mapGetters(['userInfo','storeInfo']),
      storeId () { return this.$route.query.store },
      orderId () { return this.$route.query.orderId },
      commentId () { return this.$route.query.commentId },
      orderType () { return this.$route.query.orderType },
      //是否显示管理员审核评论的按钮
      showControlBtn() {
        let t = this.userInfo.type,v = this.CommentDetail[0].is_verify,r = this.CommentDetail[0].reply_is_verify;
        return t === 99 && (!v || (!r && this.CommentDetail[0].reply));
      },
      //是否显示门店回复评论输入框
      showStoreReply() {
        return !this.CommentDetail[0].reply && this.$GFUN.isInArray([3,5,6,8],this.userInfo.type);
      }
    },
    async mounted () {
      this.UPDATECURRENTSTORE({ storeId: this.storeId })
      await this.getCommentDetail(this.commentId || this.orderId);
      this.CommentDetail.forEach((item,index) => {
        /*设置评分进度条宽度占比*/
        let facilitiesWidth = (item.hotel_facilities / 5) * 100;
        let attitudeWidth = (item.hotel_environment / 5) * 100;
        let currentItem = $('.progress-wrap').eq(index);
        currentItem.children(':first').find('label>span').width(facilitiesWidth + '%');
        currentItem.children(':last').find('label>span').width(attitudeWidth + '%');
      });
    },
    destroyed () {
      this.UPDATECURRENTSTORE({ storeId: '' })
    },
    methods: {
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['getCommentDetail','adminVerifyComment','storeReplyComment']),
      //管理员审核评论
      verifyComment(type) {
        this._confirm('确认操作么？',() => {
          this.adminVerifyComment({
            comment_id:this.commentId,
            is_verify:type
          })
        })
      },
      //门店回复评论
      replyPost() {
        if (!this.$GFUN.powerIsInArray([260,216,331,406,604])) { this._alert('您没有相关权限！',null,'error'); return; }
        if (!this.replyContent) { this._alert('您还没有输入回复内容',null,'error'); return; }
        this._confirm('确定提交回复么？',() => {
          this.storeReplyComment({
            comment_id:this.commentId,
            store_id:this.storeInfo.storeId,
            store_type:this.storeInfo.type,
            reply:this.replyContent
          })
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .comment-wrap {
    border-radius: 15px;
    padding: 30px 10%;
    .grade-progress {
      display: flex;
      align-items: center;
      label {
        width: 191px;
        height: 16px;
        display: flex;
        align-items: center;
        background: rgba(253, 185, 0, .4);
        border-radius: 8px;
        margin-bottom: 0;
        padding: 0 2px;
        span {
          display: inline-block;
          width: 159px;
          height: 12px;
          background: rgba(253, 185, 0, .6);
          border-radius: 6px;
        }
      }
    }
    .img-item img {
      width: 100px;
      height: 100px;
      margin-bottom: 5px;
      margin-right: 10px;
      cursor: pointer;
    }
  }

  .progress-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
